import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en_common from './locales/en/common.json';
import en_button from './locales/en/button.json';
import es_common from './locales/es/common.json';
import es_button from './locales/es/button.json';
import fn_common from './locales/fn/common.json';
import fn_button from './locales/fn/button.json';

export const defaultNS = 'common';
export const availableLanguage = [
  { name: 'English', value: 'en' },
  { name: 'Spanish', value: 'es' },
  { name: 'French', value: 'fn' },
];
const createResource = () => {
  let _res: any = {
    en: {
      common: en_common,
      button: en_button,
    },
    es: {
      common: es_common,
      button: es_button,
    },
    fn: {
      common: fn_common,
      button: fn_button,
    },
  };
  // const lang = availableLanguage?.map((lang: any) => lang?.value);
  // if (lang?.length) {
  //   lang?.forEach(async (item: any) => {
  //     const common = en_common;
  //     const button = en_button;
  //     _res[item] = {
  //       common,
  //       button,
  //     };
  //   });
  // }
  return _res;
};

i18next.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'en',
  defaultNS,
  resources: createResource(),
});

export default i18next;
